import { getResolvedApiBase, trimSlash } from "config/apiRoot";

/**
 * Create / Update Script API host — ONLY this module (see settingUpdateScript.slice + UpdateScript.js).
 *
 * Order: REACT_APP_UPDATE_SCRIPT_API_URL → same base as App (src/config/apiRoot.js: REACT_APP_API_URL,
 * then LOCAL_API_BASE in development) → "" (then axios uses Firebase base_url, often fxbazzar.com:2025).
 * Merging with apiRoot avoids script calls hitting production when axios.defaults.baseURL is not set yet.
 */

/** API root must end with /api/v1 (SettingsController route prefix). */
function normalizeApiRoot(root) {
  if (!root) return "";
  let r = String(root).trim().replace(/\/+$/, "");
  if (!/\/api\/v1$/i.test(r)) {
    r = `${r}/api/v1`;
  }
  return r;
}

function isAbsoluteApiUrl(u) {
  return /^https?:\/\//i.test(trimSlash(u));
}

export function getUpdateScriptApiRoot() {
  // npm start: REACT_APP_API_URL=/api/v1 + axios.defaults.baseURL=/api/v1.
  // Return "" here so buildUpdateScriptUrl yields "settings/scripts" only.
  // If we returned "/api/v1", axios would merge baseURL + url → /api/v1/api/v1/... (404).
  if (process.env.NODE_ENV === "development") {
    const devApi = trimSlash(process.env.REACT_APP_API_URL);
    if (devApi && !isAbsoluteApiUrl(devApi)) {
      return "";
    }
  }

  const scriptOnly = trimSlash(process.env.REACT_APP_UPDATE_SCRIPT_API_URL || "");
  if (scriptOnly) {
    return normalizeApiRoot(scriptOnly);
  }

  const unified = getResolvedApiBase("");
  if (unified) {
    return normalizeApiRoot(unified);
  }

  return "";
}

/**
 * Build URL for settings/* endpoints.
 * - Empty root → `settings/scripts` (axios adds defaults.baseURL, e.g. /api/v1)
 * - Full https root → `https://host:2025/api/v1/settings/scripts` (no baseURL merge)
 */
export function buildUpdateScriptUrl(relativePath) {
  const path = String(relativePath).replace(/^\/+/, "");
  const root = getUpdateScriptApiRoot();
  if (!root) return path;
  return `${trimSlash(root)}/${path}`;
}
